import React from "react";
import { formatDateSimple } from "../../../Utils/helper";

const RedemptionHistoryCard = ({
  title,
  subTitle,
  timestamp,
  imagePath,
  isNegative,
}) => {
  return (
    <div className="w-full bg-white">
      <div className="flex flex-row justify-between items-center border-b border-[#F0F0F0] pb-4">
        <div className="flex flex-col gap-[18px] pr-4 flex-1">
          <h3 className="text-[#253FF6] font-medium text-[16px] xs:text-lg">{title}</h3>
          <p
            className={`text-[12px] xs:text-sm font-medium ${
              isNegative ? "text-[#EF4056]" : "text-[#333333]"
            }`}
          >
            {subTitle}
          </p>
          <p className="text-xs text-gray-400 mt-1">
            {formatDateSimple(timestamp)}
          </p>
        </div>
        {imagePath && (
          <div className="flex-shrink-0 self-start pt-[10px]">
            <div className="flex items-center justify-center rounded-full shadow-badge relative flex-shrink-0 size-[50px] 2xs:size-[50px] aspect-square overflow-hidden bg-[#ECEEFF]">
              <img
                className="size-full object-contain"
                src={`${process.env.REACT_APP_URL_IMAGE}/${imagePath}`}
                alt="sticker-icon"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/images/brand.jpg";
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RedemptionHistoryCard;
